
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts/practitioner-account/profile-settings",
      function () {
        return require("private-next-pages/accounts/practitioner-account/profile-settings.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts/practitioner-account/profile-settings"])
      });
    }
  